(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
constructor() {
super();
}

connectedCallback() {
this.header = document.getElementById('shopify-section-header');
this.headerBounds = {};
this.currentScrollTop = 0;
this.preventReveal = false;
this.predictiveSearch = this.querySelector('predictive-search');

this.onScrollHandler = this.onScroll.bind(this);
this.hideHeaderOnScrollUp = () => this.preventReveal = true;

this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);

this.createObserver();
}

disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});

observer.observe(this.header);
}

onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (this.preventHide) return;
requestAnimationFrame(this.hide.bind(this));
} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (!this.preventReveal) {
requestAnimationFrame(this.reveal.bind(this));
} else {
window.clearTimeout(this.isScrolling);

this.isScrolling = setTimeout(() => {
this.preventReveal = false;
}, 66);

requestAnimationFrame(this.hide.bind(this));
}
} else if (scrollTop <= this.headerBounds.top) {
requestAnimationFrame(this.reset.bind(this));
}

this.currentScrollTop = scrollTop;
}

hide() {
this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
this.closeMenuDisclosure();
this.closeSearchModal();
}

reveal() {
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.remove('shopify-section-header-hidden');
}

reset() {
this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
}

closeMenuDisclosure() {
this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
this.disclosures.forEach(disclosure => disclosure.close());
}

closeSearchModal() {
this.searchModal = this.searchModal || this.header.querySelector('details-modal');
this.searchModal.close(false);
}
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-results-grid-v2"]) return;
  try {
    
(function() {
  'use strict';

  // Configuration - Consider moving these to theme settings or metafields
  const CONFIG = {
    storefrontAccessToken: '8e6a7b3fe1fb4bf3d00695a8c81c0ef1',
    shopifyDomain: 'https://vcp-live.myshopify.com',
    apiVersion: '2023-04',
    placeholderImage: 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?format=jpg&quality=90&v=1530129081',
    trustpilotImage: 'https://cdn.shopify.com/s/files/1/0749/4044/9045/files/Trustpilot_ratings_4halfstar-RGB-512x96.png?v=1738852057',
    trustpilotLogo: 'https://cdn.shopify.com/s/files/1/0749/4044/9045/files/Trustpilot_brandmark_white.png?v=1738852057'
  };

  // Product type mappings
  const PRODUCT_TYPES = {
    wipers: ['Rear Blade','Rear', 'Kit', 'Set', 'Retro Upgrade Kit'],
    fuelCaps: ['Fuel Cap', 'Locking Fuel Cap', 'Non Locking Fuel Cap'],
    evCables: ['EV Charger Cable'],
    carMats: ['Car Mats']
  };

  // Collection heading mappings
  const COLLECTION_HEADINGS = {
    'wipers-for-your-vehicle': 'YOUR WIPER <br/> BLADES',
    'fuel-caps-for-your-vehicle': 'YOUR FUEL <br/> CAPS',
    'ev-charging-cables': 'YOUR EV <br/> CHARGING CABLE',
    'car-mats-for-your-vehicle': 'YOUR CAR <br/> MATS'
  };

  // Currency symbols mapping
  const CURRENCY_SYMBOLS = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    CAD: 'C$',
    AUD: 'A$'
  };

  /**
   * Format price with currency symbol
   */
  function formatPrice(amount, currencyCode) {
    const symbol = CURRENCY_SYMBOLS[currencyCode] || currencyCode;
    return `${symbol}${amount}`;
  }

  /**
   * Get product type category
   */
  function getProductCategory(productType) {
    if (PRODUCT_TYPES.wipers.includes(productType)) return 'wipers';
    if (PRODUCT_TYPES.fuelCaps.includes(productType)) return 'fuelCaps';
    if (PRODUCT_TYPES.evCables.includes(productType)) return 'evCables';
    if (PRODUCT_TYPES.carMats.includes(productType)) return 'carMats';
    return null;
  }

  /**
   * Generate product card HTML
   */
  function createProductCard(product, variant) {
    const productImage = product.images.edges[0]?.node?.url || CONFIG.placeholderImage;
    const productLink = `/products/${product.handle}`;
    const variantIdShort = variant.id.substring(29);
    const formattedPrice = formatPrice(variant.price.amount, variant.price.currencyCode);
    const isAvailable = variant.quantityAvailable > 0;
    const category = getProductCategory(product.productType);

    const buttonHtml = isAvailable
      ? `<button id="quick-add-${variantIdShort}-submit"
            type="submit"
            name="add"
            class="quick-add__submit button button--full-width button--secondary"
            aria-haspopup="dialog"
            aria-live="polite"
            data-sold-out-message="false">
          <span>Add to cart</span>
          <div class="loading-overlay__spinner hidden">
            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
            </svg>
          </div>
        </button>`
      : category === 'carMats'
        ? `<a href="${productLink}" class="quick-add__submit button button--full-width button--secondary">
            See more options
          </a>`
        : `<button id="quick-add-${variantIdShort}-submit"
              type="submit"
              name="add"
              class="quick-add__submit button button--full-width button--secondary"
              aria-haspopup="dialog"
              aria-live="polite"
              data-sold-out-message="true"
              disabled>
            <span>Sold out</span>
            <div class="loading-overlay__spinner hidden">
              <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
              </svg>
            </div>
          </button>`;

    return `
      <li class="grid__item">
        <div class="card-wrapper product-card-wrapper underline-links-hover">
          <div class="card card--standard card--media" style="--ratio-percent: 100.0%;">
            <div class="card__inner color-background-2 gradient ratio" style="--ratio-percent: 100.0%;">
              <div class="card__media">
                <div class="media media--transparent media--hover-effect">
                  <img src="${productImage}" alt="${product.title}" class="product-image" loading="lazy" style="max-width: 100%;">
                </div>
              </div>
              <div class="card__content">
                <div class="card__information"></div>
                <div class="card__badge bottom left"></div>
              </div>
            </div>
            <div class="card__content">
              <div class="card__information">
                <h3 class="card__heading h5">
                  <a href="${productLink}" class="full-unstyled-link caption-01">${product.title}</a>
                </h3>
                <div class="card__information">
                  <span class="caption-large light"></span>
                  <div class="price price--on-sale">
                    <div class="price__container">
                      <div class="price__regular">
                        <span class="visually-hidden visually-hidden--inline">Regular price</span>
                        <span class="price-item price-item--regular">${formattedPrice}</span>
                      </div>
                      <div class="price__sale">
                        <span class="price-item price-item--sale price-item--last heading04M">${formattedPrice}</span>
                      </div>
                      <small class="unit-price caption hidden">
                        <span class="visually-hidden">Unit price</span>
                        <span class="price-item price-item--last">
                          <span></span>
                          <span aria-hidden="true">/</span>
                          <span class="visually-hidden">&nbsp;per&nbsp;</span>
                          <span></span>
                        </span>
                      </small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="quick-add no-js-hidden">
                <product-form>
                  <form method="post" action="/cart/add" id="quick-add-${variantIdShort}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                    <input type="hidden" name="form_type" value="product">
                    <input type="hidden" name="utf8" value="✓">
                    <input type="hidden" name="id" value="${variantIdShort}">
                    ${buttonHtml}
                  </form>
                </product-form>
              </div>
            </div>
          </div>
        </div>
      </li>`;
  }

  /**
   * Generate Your Vehicle section HTML
   */
  function createYourVehicleHtml(vehicleData, collectionHandle) {
    const headingText = COLLECTION_HEADINGS[collectionHandle] || 'YOUR VEHICLE';
    const { reg = '', make = '', model = '', body = '', fuel = '' } = vehicleData;

    return `
      <div class="inner page-width">
        <div class="guaranteed-fit body-01">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M9 12l2 2 4-4"></path>
          </svg>
          Guaranteed Fit
        </div>
        <h2 class="display02M">${headingText}</h2>
        ${reg ? `<div class="icon-reg"><div class="your-vehicle__reg">${reg}</div></div>` : ''}
        <div class="your-vehicle__details">
          <p class="body-01">${make} ${model}<br>${body}<br>${fuel}</p>
        </div>
        <div class="your-vehicle__buttons vehicle-confirm__buttons">
          <a href="/pages/find-wiper-blades" class="button button--primary">Change my vehicle</a>
        </div>
        <div class="trustpilot">
          <p class="caption-01">
            Excellent
            <img src="${CONFIG.trustpilotImage}" alt="Trustpilot Rating">
            <a href="https://www.trustpilot.com/review/www.vipacarparts.com" target="_blank">18,065 Reviews on</a>
            <img src="${CONFIG.trustpilotLogo}" alt="Trustpilot">
          </p>
        </div>
      </div>`;
  }

  /**
   * Get vehicle data from localStorage
   */
  function getVehicleData() {
    const regResult = localStorage.getItem('regResult');
    if (regResult) {
      const data = JSON.parse(regResult);
      return {
        reg: data.reg || '',
        make: data.make || '',
        model: data.model || '',
        body: data.body || '',
        fuel: data.fuel_type || ''
      };
    }

    const manualOptions = localStorage.getItem('manual_selected_options');
    if (manualOptions) {
      const data = JSON.parse(manualOptions);
      return {
        reg: '',
        make: data.make || '',
        model: data.model || '',
        body: data.bodyStyle || '',
        fuel: data.fuelType !== '0' ? data.fuelType : ''
      };
    }

    return null;
  }

  /**
   * Get collection handle from URL
   */
  function getCollectionHandle() {
    const pathSegments = window.location.pathname.split('/');
    const collectionsIndex = pathSegments.indexOf('collections');
    return collectionsIndex !== -1 ? pathSegments[collectionsIndex + 1] : '';
  }

  /**
   * Get product IDs from URL params
   */
  function getProductIdsFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const idsParam = urlParams.get('ids');
    if (!idsParam) return [];
    return idsParam.split(',').map(id => `gid://shopify/Product/${id}`);
  }

  /**
   * GraphQL query for fetching products
   */
  const PRODUCTS_QUERY = `
    query($ids: [ID!]!) {
      nodes(ids: $ids) {
        ... on Product {
          id
          title
          handle
          productType
          blade_size: metafield(namespace: "custom", key: "blade_size") {
            value
          }
          images(first: 1) {
            edges {
              node {
                id
                altText
                url(transform: { maxWidth: 400 })
              }
            }
          }
          variants(first: 1) {
            edges {
              node {
                id
                title
                sku
                price {
                  amount
                  currencyCode
                }
                quantityAvailable
              }
            }
          }
        }
      }
    }
  `;

  /**
   * Fetch products from Shopify Storefront API
   */
  async function fetchProducts(productIds) {
    const response = await fetch(`${CONFIG.shopifyDomain}/api/${CONFIG.apiVersion}/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': CONFIG.storefrontAccessToken
      },
      body: JSON.stringify({
        query: PRODUCTS_QUERY,
        variables: { ids: productIds }
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.data.nodes.filter(Boolean);
  }

  /**
   * Render products to their respective grids
   */
  function renderProducts(products) {
    const productsByCategory = {
      wipers: [],
      fuelCaps: [],
      evCables: [],
      carMats: []
    };

    // Categorize products
    products.forEach(product => {
      if (!product || !product.variants?.edges?.length) return;

      const category = getProductCategory(product.productType);
      if (category) {
        const variant = product.variants.edges[0].node;
        productsByCategory[category].push(createProductCard(product, variant));
      }
    });

    // Render to grids
    const gridMappings = {
      wipers: 'product-grid',
      fuelCaps: 'product-grid-caps',
      evCables: 'product-grid-ev',
      carMats: 'product-grid-car-mats'
    };

    Object.entries(gridMappings).forEach(([category, gridId]) => {
      const grid = document.getElementById(gridId);
      if (grid) {
        grid.innerHTML = productsByCategory[category].join('');
      }
    });

    // Hide empty sections (title + grid container)
    const hideSectionIfEmpty = (titleId, gridId, products) => {
      if (products.length === 0) {
        const title = document.getElementById(titleId);
        const grid = document.getElementById(gridId);
        if (title) title.style.display = 'none';
        if (grid?.parentElement) grid.parentElement.style.display = 'none';
      }
    };

    hideSectionIfEmpty('car_mats_collection', 'product-grid-car-mats', productsByCategory.carMats);
    hideSectionIfEmpty('wipers_collection', 'product-grid', productsByCategory.wipers);
  }

  /**
   * Render vehicle information
   */
  function renderVehicleInfo() {
    const yourVehicleDiv = document.getElementById('your-vehicle');
    if (!yourVehicleDiv) return;

    const vehicleData = getVehicleData();
    if (!vehicleData) return;

    const collectionHandle = getCollectionHandle();
    yourVehicleDiv.innerHTML = createYourVehicleHtml(vehicleData, collectionHandle);
  }

  /**
   * Initialize the component
   */
  async function init() {
    const productIds = getProductIdsFromUrl();
    if (productIds.length === 0) return;

    try {
      const products = await fetchProducts(productIds);
      renderProducts(products);
      renderVehicleInfo();
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-results-grid"]) return;
  try {
    
(function() {
  'use strict';

  console.log('Template Updated');

  // Configuration - Consider moving these to theme settings or metafields
  const CONFIG = {
    storefrontAccessToken: '8e6a7b3fe1fb4bf3d00695a8c81c0ef1',
    shopifyDomain: 'https://vcp-live.myshopify.com',
    apiVersion: '2023-04',
    placeholderImage: 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?format=jpg&quality=90&v=1530129081',
    trustpilotImage: 'https://cdn.shopify.com/s/files/1/0749/4044/9045/files/Trustpilot_ratings_4halfstar-RGB-512x96.png?v=1738852057',
    trustpilotLogo: 'https://cdn.shopify.com/s/files/1/0749/4044/9045/files/Trustpilot_brandmark_white.png?v=1738852057'
  };

  // Product type mappings
  const PRODUCT_TYPES = {
    wipers: ['Rear Blade','Rear', 'Kit', 'Set', 'Retro Upgrade Kit'],
    fuelCaps: ['Fuel Cap', 'Locking Fuel Cap', 'Non Locking Fuel Cap'],
    evCables: ['EV Charger Cable'],
    carMats: ['Car Mats']
  };

  // Collection heading mappings
  const COLLECTION_HEADINGS = {
    'wipers-for-your-vehicle': 'YOUR WIPER <br/> BLADES',
    'fuel-caps-for-your-vehicle': 'YOUR FUEL <br/> CAPS',
    'ev-charging-cables': 'YOUR EV <br/> CHARGING CABLE',
    'car-mats-for-your-vehicle': 'YOUR CAR <br/> MATS'
  };

  // Currency symbols mapping
  const CURRENCY_SYMBOLS = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    CAD: 'C$',
    AUD: 'A$'
  };

  /**
   * Format price with currency symbol
   */
  function formatPrice(amount, currencyCode) {
    const symbol = CURRENCY_SYMBOLS[currencyCode] || currencyCode;
    return `${symbol}${amount}`;
  }

  /**
   * Get product type category
   */
  function getProductCategory(productType) {
    if (PRODUCT_TYPES.wipers.includes(productType)) return 'wipers';
    if (PRODUCT_TYPES.fuelCaps.includes(productType)) return 'fuelCaps';
    if (PRODUCT_TYPES.evCables.includes(productType)) return 'evCables';
    if (PRODUCT_TYPES.carMats.includes(productType)) return 'carMats';
    return null;
  }

  /**
   * Generate product card HTML
   */
  function createProductCard(product, variant) {
    const productImage = product.images.edges[0]?.node?.url || CONFIG.placeholderImage;
    const productLink = `/products/${product.handle}`;
    const variantIdShort = variant.id.substring(29);
    const formattedPrice = formatPrice(variant.price.amount, variant.price.currencyCode);
    const isAvailable = variant.quantityAvailable > 0;
    const category = getProductCategory(product.productType);

    const buttonHtml = isAvailable
      ? `<button id="quick-add-${variantIdShort}-submit"
            type="submit"
            name="add"
            class="quick-add__submit button button--full-width button--secondary"
            aria-haspopup="dialog"
            aria-live="polite"
            data-sold-out-message="false">
          <span>Add to cart</span>
          <div class="loading-overlay__spinner hidden">
            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
            </svg>
          </div>
        </button>`
      : category === 'carMats'
        ? `<a href="${productLink}" class="quick-add__submit button button--full-width button--secondary">
            See more options
          </a>`
        : `<button id="quick-add-${variantIdShort}-submit"
              type="submit"
              name="add"
              class="quick-add__submit button button--full-width button--secondary"
              aria-haspopup="dialog"
              aria-live="polite"
              data-sold-out-message="true"
              disabled>
            <span>Sold out</span>
            <div class="loading-overlay__spinner hidden">
              <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
              </svg>
            </div>
          </button>`;

    return `
      <li class="grid__item">
        <div class="card-wrapper product-card-wrapper underline-links-hover">
          <div class="card card--standard card--media" style="--ratio-percent: 100.0%;">
            <div class="card__inner color-background-2 gradient ratio" style="--ratio-percent: 100.0%;">
              <div class="card__media">
                <div class="media media--transparent media--hover-effect">
                  <img src="${productImage}" alt="${product.title}" class="product-image" loading="lazy" style="max-width: 100%;">
                </div>
              </div>
              <div class="card__content">
                <div class="card__information"></div>
                <div class="card__badge bottom left"></div>
              </div>
            </div>
            <div class="card__content">
              <div class="card__information">
                <h3 class="card__heading h5">
                  <a href="${productLink}" class="full-unstyled-link caption-01">${product.title}</a>
                </h3>
                <div class="card__information">
                  <span class="caption-large light"></span>
                  <div class="price price--on-sale">
                    <div class="price__container">
                      <div class="price__regular">
                        <span class="visually-hidden visually-hidden--inline">Regular price</span>
                        <span class="price-item price-item--regular">${formattedPrice}</span>
                      </div>
                      <div class="price__sale">
                        <span class="price-item price-item--sale price-item--last heading04M">${formattedPrice}</span>
                      </div>
                      <small class="unit-price caption hidden">
                        <span class="visually-hidden">Unit price</span>
                        <span class="price-item price-item--last">
                          <span></span>
                          <span aria-hidden="true">/</span>
                          <span class="visually-hidden">&nbsp;per&nbsp;</span>
                          <span></span>
                        </span>
                      </small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="quick-add no-js-hidden">
                <product-form>
                  <form method="post" action="/cart/add" id="quick-add-${variantIdShort}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                    <input type="hidden" name="form_type" value="product">
                    <input type="hidden" name="utf8" value="✓">
                    <input type="hidden" name="id" value="${variantIdShort}">
                    ${buttonHtml}
                  </form>
                </product-form>
              </div>
            </div>
          </div>
        </div>
      </li>`;
  }

  /**
   * Generate Your Vehicle section HTML
   */
  function createYourVehicleHtml(vehicleData, collectionHandle) {
    const headingText = COLLECTION_HEADINGS[collectionHandle] || 'YOUR VEHICLE';
    const { reg = '', make = '', model = '', body = '', fuel = '' } = vehicleData;

    return `
      <div class="inner page-width">
        <div class="guaranteed-fit body-01">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M9 12l2 2 4-4"></path>
          </svg>
          Guaranteed Fit
        </div>
        <h2 class="display02M">${headingText}</h2>
        ${reg ? `<div class="icon-reg"><div class="your-vehicle__reg"><span class="vipa-plate__number">${reg}</span></div></div>` : ''}
        <div class="your-vehicle__details">
          <p class="body-01">${make} ${model}<br>${body}<br>${fuel}</p>
        </div>
        <div class="your-vehicle__buttons vehicle-confirm__buttons">
          <a href="/pages/find-wiper-blades" class="button button--primary">Change my vehicle</a>
        </div>
        <div class="trustpilot">
          <p class="caption-01">
            Excellent
            <img src="${CONFIG.trustpilotImage}" alt="Trustpilot Rating">
            <a href="https://www.trustpilot.com/review/www.vipacarparts.com" target="_blank">18,065 Reviews on</a>
            <img src="${CONFIG.trustpilotLogo}" alt="Trustpilot">
          </p>
        </div>
      </div>`;
  }

  /**
   * Get vehicle data from localStorage
   */
  function getVehicleData() {
    const regResult = localStorage.getItem('regResult');
    if (regResult) {
      const data = JSON.parse(regResult);
      return {
        reg: data.reg || '',
        make: data.make || '',
        model: data.model || '',
        body: data.body || '',
        fuel: data.fuel_type || ''
      };
    }

    const manualOptions = localStorage.getItem('manual_selected_options');
    if (manualOptions) {
      const data = JSON.parse(manualOptions);
      return {
        reg: '',
        make: data.make || '',
        model: data.model || '',
        body: data.bodyStyle || '',
        fuel: data.fuelType !== '0' ? data.fuelType : ''
      };
    }

    return null;
  }

  /**
   * Get collection handle from URL
   */
  function getCollectionHandle() {
    const pathSegments = window.location.pathname.split('/');
    const collectionsIndex = pathSegments.indexOf('collections');
    return collectionsIndex !== -1 ? pathSegments[collectionsIndex + 1] : '';
  }

  /**
   * Get product IDs from URL params
   */
  function getProductIdsFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const idsParam = urlParams.get('ids');
    if (!idsParam) return [];
    return idsParam.split(',').map(id => `gid://shopify/Product/${id}`);
  }

  /**
   * GraphQL query for fetching products
   */
  const PRODUCTS_QUERY = `
    query($ids: [ID!]!) {
      nodes(ids: $ids) {
        ... on Product {
          id
          title
          handle
          productType
          blade_size: metafield(namespace: "custom", key: "blade_size") {
            value
          }
          images(first: 1) {
            edges {
              node {
                id
                altText
                url(transform: { maxWidth: 400 })
              }
            }
          }
          variants(first: 1) {
            edges {
              node {
                id
                title
                sku
                price {
                  amount
                  currencyCode
                }
                quantityAvailable
              }
            }
          }
        }
      }
    }
  `;

  /**
   * Fetch products from Shopify Storefront API
   */
  async function fetchProducts(productIds) {
    const response = await fetch(`${CONFIG.shopifyDomain}/api/${CONFIG.apiVersion}/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': CONFIG.storefrontAccessToken
      },
      body: JSON.stringify({
        query: PRODUCTS_QUERY,
        variables: { ids: productIds }
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.data.nodes.filter(Boolean);
  }

  /**
   * Render products to their respective grids
   */
  function renderProducts(products) {
    const productsByCategory = {
      wipers: [],
      fuelCaps: [],
      evCables: [],
      carMats: []
    };

    // Categorize products
    products.forEach(product => {
      if (!product || !product.variants?.edges?.length) return;

      const category = getProductCategory(product.productType);
      if (category) {
        const variant = product.variants.edges[0].node;
        productsByCategory[category].push(createProductCard(product, variant));
      }
    });

    // Render to grids
    const gridMappings = {
      wipers: 'product-grid',
      fuelCaps: 'product-grid-caps',
      evCables: 'product-grid-ev',
      carMats: 'product-grid-car-mats'
    };

    Object.entries(gridMappings).forEach(([category, gridId]) => {
      const grid = document.getElementById(gridId);
      if (grid) {
        grid.innerHTML = productsByCategory[category].join('');
      }
    });

    // Empty section messages based on collection
    const EMPTY_MESSAGES = {
      'car-mats-for-your-vehicle': {
        mats: "Sorry — we don't have mats available for your specific vehicle just yet. However, have you thought about upgrading your wiper blades? Compatible wiper options are displayed below."
      },
      'wipers-for-your-vehicle': {
        mats: "Sorry — we don't have mats available for your specific vehicle just yet."
      }
    };

    // Handle empty sections
    const handleEmptySection = (titleId, gridId, products, emptyMessage = null) => {
      if (products.length === 0) {
        const title = document.getElementById(titleId);
        const grid = document.getElementById(gridId);

        if (emptyMessage && title) {
          // Show message instead of hiding, with custom styling
          const h2 = title.querySelector('h2');
          h2.textContent = emptyMessage;
          h2.style.fontSize = 'xx-large';
          if (grid?.parentElement) grid.parentElement.style.display = 'none';
        } else {
          // Hide both title and grid
          if (title) title.style.display = 'none';
          if (grid?.parentElement) grid.parentElement.style.display = 'none';
        }
      }
    };

    const collectionHandle = getCollectionHandle();
    const messages = EMPTY_MESSAGES[collectionHandle] || {};

    handleEmptySection('car_mats_collection', 'product-grid-car-mats', productsByCategory.carMats, messages.mats);
    handleEmptySection('wipers_collection', 'product-grid', productsByCategory.wipers);
  }

  /**
   * Render vehicle information
   */
  function renderVehicleInfo() {
    const yourVehicleDiv = document.getElementById('your-vehicle');
    if (!yourVehicleDiv) return;

    const vehicleData = getVehicleData();
    if (!vehicleData) return;

    const collectionHandle = getCollectionHandle();
    yourVehicleDiv.innerHTML = createYourVehicleHtml(vehicleData, collectionHandle);
  }

  /**
   * Initialize the component
   */
  async function init() {
    const productIds = getProductIdsFromUrl();
    if (productIds.length === 0) return;

    try {
      const products = await fetchProducts(productIds);
      renderProducts(products);
      renderVehicleInfo();
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vipa-make-scroll-cue"]) return;
  try {
    
(function(){
  'use strict';
  function connectMakeCue(){
    var cue=document.querySelector('[data-vipa-make-scroll-cue]');
    if(!cue||!document.querySelector('.vipa-make-navigation'))return;
    var root=document.querySelector('#MainContent .reg-finder-container');
    var form=root&&root.querySelector('form#reg-finder-form');
    var formBlock=form&&form.closest('.reg-finder__block');
    if(formBlock&&root.contains(formBlock)){
      var source=cue.closest('.vipa-make-cue-section');
      var slot=root.querySelector('[data-vipa-cue-below-registration]');
      if(!slot){
        slot=document.createElement('div');
        slot.className='vipa-make-cue-under-reg';
        slot.setAttribute('data-vipa-cue-below-registration','true');
        formBlock.insertAdjacentElement('afterend',slot);
      }
      if(cue.parentElement!==slot)slot.appendChild(cue);
      cue.setAttribute('data-vipa-cue-location','below-registration');
      root.classList.add('vipa-make-cue-host');
      /* Only the app containers enclosing THIS form are allowed to shrink.
         Neither the form itself, its controls nor any popup is changed. */
      var ancestor=formBlock.parentElement;
      while(ancestor&&ancestor!==root&&root.contains(ancestor)){
        ancestor.classList.add('vipa-make-cue-flow');
        ancestor=ancestor.parentElement;
      }
      if(source)source.classList.add('vipa-make-cue-moved');
    }
    var extras=document.querySelector('.vipa-result-extras');
    if(!extras)return;
    [[cue.querySelector('[data-make-cue-fitting]'),extras.querySelector('.vipa-result-extras__help'),'vipa-make-fitting-help'],[cue.querySelector('[data-make-cue-extras]'),extras.querySelector('.vipa-result-extras__head'),'vipa-make-extras-below']].forEach(function(pair){
      var link=pair[0],target=pair[1];
      if(!link||!target)return;
      if(!target.id){var candidate=pair[2],suffix=1;while(document.getElementById(candidate)){candidate=pair[2]+'-'+suffix++;}target.id=candidate;}
      target.classList.add('vipa-make-cue-destination');
      link.href='#'+target.id;
    });
  }
  function start(){connectMakeCue();setTimeout(connectMakeCue,300);setTimeout(connectMakeCue,1000);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  window.addEventListener('load',connectMakeCue,{once:true});
  document.addEventListener('shopify:section:load',connectMakeCue);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vipa-results-sale-display"]) return;
  try {
    
(function(){
  'use strict';

  function startVipaResultsSale(){
    var hook=document.querySelector('[data-vipa-results-sale-hook]');
    var grid=document.querySelector('#ProductGridContainer #product-grid');
    if(!hook||!grid||hook.dataset.active!=='true'||hook.dataset.bound==='true')return;
    hook.dataset.bound='true';

    function parseMoney(text){
      text=String(text||'').replace(/\s+/g,' ').trim();
      var symbol=(text.match(/[£$€]/)||['£'])[0];
      var number=(text.match(/[0-9][0-9,]*(?:\.[0-9]{1,2})?/)||[])[0];
      if(!number)return null;
      var amount=Number(number.replace(/,/g,''));
      if(!Number.isFinite(amount))return null;
      return {symbol:symbol,minor:Math.round(amount*100)};
    }

    function formatMoney(symbol,minor){
      return symbol+(minor/100).toFixed(2);
    }

    function applySale(card){
      if(!card||card.dataset.vipaResultsSaleReady==='true')return;
      var originalPrice=card.querySelector('.price');
      if(!originalPrice)return;

      var sourceNode=originalPrice.querySelector('.price-item--sale.price-item--last, .price-item--regular, .price-item');
      var parsed=parseMoney(sourceNode&&sourceNode.textContent);
      if(!parsed||parsed.minor<=0)return;

      var reduction=Math.floor(parsed.minor*5/100);
      if(reduction<=0)return;
      var saleMinor=parsed.minor-reduction;

      var wrapper=document.createElement('div');
      wrapper.className='vipa-results-price-display';
      wrapper.setAttribute('data-vipa-direct-sale','true');
      wrapper.innerHTML=
        '<div class="price price--on-sale" data-vipa-offer="wipers-5-october-2026">'+
          '<div class="price__container">'+
            '<div class="price__sale">'+
              '<span><s class="price-item price-item--regular heading04M">'+formatMoney(parsed.symbol,parsed.minor)+'</s></span>'+
              '<span class="price-item price-item--sale price-item--last heading04M">'+formatMoney(parsed.symbol,saleMinor)+'</span>'+
              '<span class="vipa-results-offer-badge">5% off</span>'+
            '</div>'+
          '</div>'+
        '</div>'+
        '<p class="vipa-weekend-price-note">5% off automatically at checkout</p>';

      originalPrice.replaceWith(wrapper);
      card.dataset.vipaResultsSaleReady='true';
    }

    function scan(){
      grid.querySelectorAll('.product-card-wrapper').forEach(applySale);
    }

    var observer=new MutationObserver(function(){scan();});
    observer.observe(grid,{childList:true,subtree:true});
    scan();
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',startVipaResultsSale,{once:true});
  else startVipaResultsSale();
  document.addEventListener('shopify:section:load',startVipaResultsSale);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vipa-results-scroll-cue"]) return;
  try {
    
(function(){
  'use strict';
  var path=window.location.pathname;
  if(!/\/collections\/wipers-for-your-vehicle\/?$/.test(path))return;
  var observer=null;
  function mount(){
    var source=document.querySelector('template[data-vipa-scroll-cue-template]');
    var grid=document.querySelector('#ProductGridContainer #product-grid');
    var previous=document.querySelector('#ProductGridContainer .vipa-results-sectionbar');
    if(!source||!grid||!previous||previous.hasAttribute('data-vipa-scroll-cue'))return;
    var cue=source.content.firstElementChild.cloneNode(true);
    previous.replaceWith(cue);
    function destination(element,preferred){
      if(!element.id){var key=preferred,n=1;while(document.getElementById(key)){key=preferred+'-'+n++;}element.id=key;}
      element.classList.add('vipa-cue-destination');
      return '#'+element.id;
    }
    function picture(tile,original){
      if(!original)return false;
      var src=original.currentSrc||original.getAttribute('src');
      if(!src)return false;
      try{var u=new URL(src,window.location.href);if(u.protocol!=='https:'&&u.protocol!=='http:')return false;}catch(e){return false;}
      var img=tile.querySelector('[data-vipa-cue-image]');
      if(img.getAttribute('src')!==src){img.src=src;}
      return true;
    }
    function update(){
      var tiles={};
      cue.querySelectorAll('[data-vipa-cue-kind]').forEach(function(t){tiles[t.getAttribute('data-vipa-cue-kind')]=t;t.hidden=true;});
      var items=Array.from(grid.children).filter(function(el){return el.tagName==='LI';});
      var rows=items.map(function(el){var heading=el.querySelector('.card__heading');return {el:el,title:heading?heading.textContent.trim():''};});
      var rear=rows.find(function(row){return /\brear\b/i.test(row.title)&&!(/\bfront\b|\bkit\b|\bset\b/i.test(row.title));});
      var front=rows.find(function(row){return /\bkit\b/i.test(row.title);})||rows.find(function(row){return row!==rear&&/\bfront\b|\bset\b/i.test(row.title);});
      [['front',front],['rear',rear]].forEach(function(entry){var tile=tiles[entry[0]],row=entry[1];if(!row)return;if(picture(tile,row.el.querySelector('img.product-image, .card__media img'))){tile.href=destination(row.el,'vipa-cue-'+entry[0]);tile.hidden=false;}});
      var extras=document.querySelector('.vipa-result-extras');
      var fitting=extras&&extras.querySelector('.vipa-result-extras__help');
      if(fitting){tiles.fitting.href=destination(fitting,'vipa-cue-fitting');tiles.fitting.hidden=false;}
      if(extras){
        var wash=extras.querySelector('.vipa-result-extras__mini-image[href*="screenwash"]');
        var extraImage=wash?wash.querySelector('img'):extras.querySelector('.vipa-result-extras__mini-image img');
        if(picture(tiles.extras,extraImage)){
          tiles.extras.href=destination(extras,'vipa-cue-extras');tiles.extras.hidden=false;
          tiles.extras.querySelector('[data-vipa-cue-extras-label]').textContent=wash?'Screenwash & extras':'Car-care extras';
        }
      }
      var count=Object.keys(tiles).filter(function(key){return !tiles[key].hidden;}).length;
      var nav=cue.querySelector('.vipa-scroll-cue__categories');
      nav.hidden=count===0;nav.style.setProperty('--vipa-cue-items',String(count||1));
      var description=cue.querySelector('[data-vipa-cue-description]');
      var categories=[];
      if(!tiles.front.hidden)categories.push('Front sets');
      if(!tiles.rear.hidden)categories.push(categories.length?'rear blades':'Rear blades');
      if(!categories.length)categories.push('Your matched wipers');
      if(!tiles.fitting.hidden)categories.push('fitting help');
      if(!tiles.extras.hidden)categories.push('car-care extras');
      description.textContent=categories.length>1?categories.slice(0,-1).join(', ')+' and '+categories[categories.length-1]+' below.':categories[0]+' below.';
    }
    update();
    if(observer)observer.disconnect();
    observer=new MutationObserver(update);
    observer.observe(grid,{childList:true});
    window.addEventListener('pagehide',function(){if(observer)observer.disconnect();},{once:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount,{once:true});else mount();
  document.addEventListener('shopify:section:load',mount);
})();

  } catch(e) { console.error(e); }
})();
})();
